import { ALL_ICON_REFS } from "./icon-packs";
import { CATEGORY_LAYOUTS, type CategoryLayout } from "./types";

/** Icon, colour and layout keys the data may reference. The UI draws them (src/ui/icons.ts); a unit test keeps both lists equal. */
export const ICON_KEYS: readonly string[] = ALL_ICON_REFS;
export const COLOR_KEYS = ["violet","green","sky","amber","orange","rose","pink","slate"] as const;
export const LAYOUT_KEYS: readonly CategoryLayout[] = CATEGORY_LAYOUTS.map(l => l.key);

export const isIcon = (v: unknown): v is string => typeof v === "string" && ICON_KEYS.includes(v);
export const isColor = (v: unknown): v is string => typeof v === "string" && (COLOR_KEYS as readonly string[]).includes(v);
export const isLayout = (v: unknown): v is CategoryLayout => typeof v === "string" && (LAYOUT_KEYS as readonly string[]).includes(v);
